var DateMode;
(function (DateMode) {
  DateMode["DAY_MONTH_YEAR"] = "day-month-year";
  DateMode["MONTH_YEAR"] = "month-year";
})(DateMode || (DateMode = {}));

export { DateMode };
//# sourceMappingURL=dateMode.mjs.map
